import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCZ: CultureInfo = {
  name: 'en-CZ',
  displayName: 'English (Czechia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CZ',
  parent: CultureInfoEn
};
